import classNames from 'classnames';
import { useField } from 'formik';
import * as bd from 'react-basic-design';
import { code } from '../basic/code';
import { translate } from '../basic/text';
import { DateInput, TDateChangeEvent } from '../basic/date-input';

type FormikDateInputProps = {
    label?: string | React.ReactNode;
    labelWidth?: number;
    placeholder?: string;
    autoFocus?: boolean;
    disabled?: boolean;
    name: string;
    isHidden?: boolean;
    id?: string;
    type?: string;
    inputClassName?: string;
    controlClassName?: string;
    autoComplete?: boolean | string;
    spellCheck?: boolean | string;
    readOnly?: boolean;
    className?: string;
    width?: number | string;
    maxWidth?: number | string;
    inputStyle?: any;
    inputMaxWidth?: string | number;
    handleEnter?: VoidFunction;
    onChange?: (e: TDateChangeEvent) => void;
};

export const FormikDateInput = ({
    isHidden = false,
    label,
    labelWidth = 0,
    id,
    autoFocus,
    disabled,
    name,
    type = 'text',
    inputClassName,
    controlClassName,
    autoComplete = false,
    spellCheck = false,
    readOnly = false,
    className,
    width,
    maxWidth,
    inputStyle,
    inputMaxWidth,
    onChange,
    handleEnter,
    ...props
}: FormikDateInputProps) => {
    const [field, meta] = useField({ type, name });
    if (isHidden) return null;
    if (!type) type = 'text';
    if (!autoComplete) autoComplete = 'off';
    if (!spellCheck) spellCheck = 'false';
    if (label && name && !id) id = name;

    const onChangeHandler = (e: TDateChangeEvent) => {
        field.onChange(e);
        onChange && onChange(e);
    };

    const onKeyDownHandler = (event: any): void => {
        if (event.key.toLowerCase() === 'enter') {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            if (event.shiftKey) {
                if (index > 0) form.elements[index - 1].focus();
            } else {
                if (index + 1 < form.elements.length) form.elements[index + 1].focus();
            }
            event.preventDefault();
        }
    };

    if (!inputMaxWidth) inputMaxWidth = '10rem';
    inputStyle = { ...inputStyle, maxWidth: inputMaxWidth };

    meta.error = translate(meta.error);

    return (
        <bd.FormRow
            label={translate(label)}
            labelWidth={labelWidth > 0 ? labelWidth : undefined}
            htmlFor={id}
            className={className}
            width={width}
            maxWidth={maxWidth ?? ''}
        >
            <div className={classNames(controlClassName)}>
                <DateInput
                    autoFocus={autoFocus}
                    disabled={disabled}
                    id={id}
                    type={type}
                    className="w-100"
                    inputClassName={classNames(inputClassName, { 'bd-border-error': meta.error })}
                    autoComplete={autoComplete === 'true' || autoComplete === true ? 'on' : 'off'}
                    spellCheck={spellCheck === 'true' || spellCheck === true}
                    title={meta.error}
                    {...field}
                    {...props}
                    // value={field.value || ""}
                    value={field.value && code.isValidDate(field.value) ? field.value : ''}
                    inputStyle={inputStyle}
                    readOnly={readOnly}
                    error={meta.error}
                    showErrorLabel
                    onKeyDown={handleEnter ? onKeyDownHandler : undefined}
                    onChange={onChangeHandler}
                />
            </div>
        </bd.FormRow>
    );
};
